import { render, staticRenderFns } from "./GoodDetails.vue?vue&type=template&id=03ccfc57&scoped=true"
import script from "./GoodDetails.vue?vue&type=script&lang=js"
export * from "./GoodDetails.vue?vue&type=script&lang=js"
import style0 from "./GoodDetails.vue?vue&type=style&index=0&id=03ccfc57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ccfc57",
  null
  
)

export default component.exports